import { completeYearlyCheck } from '@/api'
import { useInvalidateOnSuccessMutation } from '@/utils'

export const useCompleteYearlyCheck = (locationId: string) =>
  useInvalidateOnSuccessMutation(
    ['company', ['location', locationId], ['location1', locationId]],
    ({ createdInsuranceIds }) =>
      completeYearlyCheck(locationId, { createdInsuranceIds }),
  )
